import { toPersistentStream } from '@ardoq/rxbeach';
import { handleError } from '@ardoq/api';
import type { MetaModel } from '@ardoq/api-types';
import { loadMetaModel$ } from 'architectureModel/loadMetaModel';

const emptyMetaModel: MetaModel = {
  componentTypes: [],
  referenceTypes: [],
  triples: [],
};

/**
 * The org metamodel. Persistent, so sending a chat message is never gated on
 * the metamodel having loaded.
 */
export const loadedMetamodel$ = toPersistentStream<MetaModel>(
  'traversalBuildingLoadedMetamodel$',
  loadMetaModel$.pipe(handleError()),
  emptyMetaModel
);
